import * as React from "react";
import * as PropTypes from "prop-types";
import { LuMaximize2, LuMinimize2, LuX } from "react-icons/lu";
import { cn } from "./utils";
import Tooltip from "./tipTool";

const Modal = React.forwardRef(function Modal(props, ref) {
  const { title, children, controls = {}, className, style, fullscreen, onFullScreenChange } = props;
  const [isFullScreen, setIsFullScreen] = React.useState(fullscreen);

  React.useEffect(() => {
    onFullScreenChange(isFullScreen);
  }, [isFullScreen]);

  function handleToggleFullScreen() {
    setIsFullScreen(!isFullScreen);
  }

  return (
  <><dialog
  ref={ref}
  style={{
    width: isFullScreen ? "100dvw" : "80dvw",
    height: isFullScreen ? "100dvh" : "92dvh",
    position: "fixed", 
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    ...style,
  }}
  className={cn("w-[80dvw] bg-[#fff] rounded-[12px] outline-none", className)}
>
  <div className="h-full flex flex-col">
    <header className="h-[60px] py-4 px-[24px] flex items-center justify-between text-[24px] border-b">
      <div className="leading-[60px] font-semibold">{title}</div>
      {controls.header && (
        <div className={cn("flex items-center justify-between h-full", controls?.className)}>
          {controls?.header?.comp}
        </div>
      )}
     <div className="flex items-center p-[10px] gap-[10px] text-[20px]">
  <Tooltip label={isFullScreen ? "Minimize" : "Maximize"}>
    <div className="cursor-pointer" onClick={handleToggleFullScreen}>
      {isFullScreen ? <LuMinimize2 /> : <LuMaximize2 />}
    </div>
  </Tooltip>
  <div className="cursor-pointer" onClick={() => ref.current.close()}>
    <LuX />
  </div>
</div>

    </header>
    <div className="grow h-[calc(100%-60px)]">{children}</div>
    {controls?.footer && (
      <div className={cn("flex items-center justify-between h-[120px]", controls?.className)}>
        {controls?.footer?.comp}
      </div>
    )}
  </div>
</dialog>
</>
  );
});

export default Modal;

Modal.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  controls: PropTypes.object,
  style: PropTypes.object,
  fullscreen: PropTypes.bool,
  onFullScreenChange: PropTypes.func,
  className: PropTypes.string,
};
